import { motion } from "framer-motion";
import { FlaskConical } from "lucide-react";

export const Ingredients = () => (
  <section id="ingredients" className="max-w-7xl mx-auto px-6 sm:px-10 pb-20 sm:pb-28 scroll-mt-36" data-testid="ingredients-section">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="bg-[#EDE3D6] rounded-2xl px-8 sm:px-14 py-12 sm:py-14 flex flex-col sm:flex-row items-start sm:items-center gap-8"
    >
      <div className="w-14 h-14 rounded-full bg-[#FFFDF9] flex items-center justify-center shrink-0">
        <FlaskConical size={24} className="text-[#C9A45C]" strokeWidth={1.5} />
      </div>
      <div>
        <h2 className="font-serif-display font-medium text-3xl tracking-tight text-[#2B1F1B]">Ingredients</h2>
        <p className="mt-2 font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#C9A45C]">Full INCI list — CELUSTA Leave-In Conditioner</p>
        <p className="mt-4 text-base font-light leading-relaxed text-[#4A3C34] max-w-3xl" data-testid="ingredients-inci-list">
          Water, Cetearyl Alcohol, Glycerin, Amodimethicone, Hydroxypropyl Starch Phosphate, Phenoxyethanol,
          Parfum, Ceteareth-20, CI 60730, Citric Acid, Cetrimonium Chloride.
        </p>
      </div>
    </motion.div>
  </section>
);
